package nl.astraeus.wiki.messages

class GetWikiMessage() : Message(
  MessageType.GET_WIKI,
  MessageHeader.WIKI_ID,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(wikiId: Long) : this() {
    setHeader(MessageHeader.WIKI_ID, wikiId.toString())
  }

}
